export default "__VITE_ASSET__DWr8bgZE__"